import { defineStore } from 'pinia';
import { configRequest } from 'config-request';
import { useGlobalStore } from './global';
import { getRequestIns } from '../requestIns';
import { isEmpty } from '../utils';
import { useFeatureListStore } from './feature-list';
export const useQuotationStore = defineStore('quotation', {
    state() {
        return {
            data: null,
            preShowAllData: null,
            hasDiffConfig: false,
            lastOption: {},
            quotation_no: '',
            pageType: 'new', //默认是新增报价单
        };
    },
    getters: {
        /**
         * 图片
         */
        configImgs() {
            let logo_url = '';
            let img_url = '';
            if (this.data?.logo_url) {
                logo_url = this.data.logo_url;
            }
            if (this.data?.img_url) {
                img_url = this.data.img_url;
            }
            return {
                logo_url,
                img_url,
            };
        },
    },
    actions: {
        async formatFeatureList(shoAllData) {
            if (!shoAllData)
                return;
            const globalData = useGlobalStore();
            const configs = shoAllData.option_list.map((option) => {
                return {
                    featureCode: option.feature_code,
                    code: option.code,
                    selected: true,
                };
            });
            const model_code = {
                featureCode: 'model_code',
                code: shoAllData.model_code,
                selected: true,
            };
            configs.push(model_code);
            const generation_code = {
                featureCode: 'generation_code',
                code: shoAllData.generation_code,
                selected: true,
            };
            configs.push(generation_code);
            if (shoAllData?.new_version) {
                globalData.updateNewVersion(shoAllData.new_version);
            }
            await globalData.batchUpdateConfig(configs, null, false);
            if (!this.preShowAllData) {
                this.lastOption = {
                    ...globalData.currentFlatOptions,
                };
            }
        },
        async queryShowAllList(token, params = {}, needCallback = false, appId = '') {
            return await this.showAllList(token, params, needCallback, appId);
        },
        /**
         * 请求配置总览
         * @param params
         */
        async showAllList(token, params, needCallback = false, appId) {
            console.log('---444请求配置总览--->>>>');
            let globalStore = useGlobalStore();
            const currentFlatOptions = globalStore.currentFlatOptions;
            // 获取当前选择的所有配置项
            const option_list = globalStore.currentOptionList.map((item) => ({
                ...item,
            }));
            let showAllParams = {};
            if (!currentFlatOptions.model_code ||
                !currentFlatOptions.generation_code) {
                showAllParams.quotation_no = params?.quotation_no;
                showAllParams.vehicle_source_id = params?.vehicle_source_id;
            }
            else {
                showAllParams = {
                    option_list,
                    generation_code: currentFlatOptions.generation_code,
                    model_code: currentFlatOptions.model_code,
                    order_person_type: currentFlatOptions.order_person_type ?? 1,
                    quotation_no: params?.quotation_no,
                    vehicle_source_id: params?.vehicle_source_id,
                };
            }
            if (!showAllParams?.quotation_no &&
                !showAllParams?.model_code &&
                !showAllParams?.vehicle_source_id) {
                return;
            }
            Object.assign(showAllParams, params);
            const result = await this.showAllRequest(showAllParams, token, appId);
            if (result?.data?.non_selectable_option_list) {
                useFeatureListStore().refreshOptionDisabledStatus(result.data.non_selectable_option_list);
            }
            if (needCallback) {
                await this.formatFeatureList(result?.data);
                if (!result || !result.data) {
                    return {
                        result: null,
                        after: async () => {
                            await this.formatFeatureList(result?.data);
                            this.data = result?.data ?? null;
                            if (!this.preShowAllData && !isEmpty(this.data))
                                this.preShowAllData = this.data;
                        },
                    };
                }
                return {
                    result: result?.data ?? null,
                    after: async () => {
                        await this.formatFeatureList(result?.data);
                        this.data = result.data || {};
                        if (!this.preShowAllData && !isEmpty(this.data))
                            this.preShowAllData = this.data;
                    },
                };
            }
            if (!result || !result.data)
                return null;
            await this.formatFeatureList(result.data);
            this.data = result?.data || null;
            if (!this.preShowAllData && !isEmpty(this.data))
                this.preShowAllData = this.data;
            return result?.data ?? null;
        },
        showAllRequest(showAllParams, token = '', appId = '') {
            return configRequest(getRequestIns()).quotation(showAllParams, {
                throwError: true,
                appId: appId,
                token: token
                    ? {
                        header: {
                            token,
                            Authorization: `Bearer ${token}`,
                        },
                    }
                    : '',
            });
        },
    },
});
